module.exports = __webpack_public_path__ + "img/noDog.0895b13c.svg";